// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.fix-rounded[data-v-18fe450a] {\n  border-radius: 4px !important;\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n.autocomplete .dropdown-menu[data-v-18fe450a] {\n  min-width: max(100%, 14em);\n  z-index: 99999 !important;\n}\n.autocomplete .dropdown-menu a.dropdown-item[data-v-18fe450a] {\n  padding-right: 0.5rem !important;\n}", ""]);
// Exports
module.exports = exports;
